module.exports = __webpack_public_path__ + "static/media/hero-bg.1787ca28.jpg";